import { BaseLayout } from '../Layout/Layout';
import { ReactComponent as GenericErrorImage } from '../../assets/images/Pitto_ErrGen.svg';
import { Button } from '../Button/Button';
import { useLanguage } from '../../locale/useLanguage';
import './GeneralError.css';
import React, { useCallback } from 'react';
import { Routes } from '../../routes/types';

type GeneralErrorProps = {};

const GeneralError: React.FC<GeneralErrorProps> = () => {
  const [t] = useLanguage();
  const close = useCallback(() => {
    window.location.href = Routes.Home;
    return;
  }, []);
  return (
    <BaseLayout isGreyBg>
      <div className="general-error--container">
        <div className="general-error--image-container">
          <GenericErrorImage className="general-error--image" />
        </div>
        <div className="general-error--content">
          <h2>{t('generalError.title')}</h2>
          <p>{t('generalError.text')}</p>
        </div>
        <div className="general-error--exit-container">
          <div className="general-error--exit-button">
            <Button onClick={close} label={t('generalError.close')} />
          </div>
        </div>
      </div>
    </BaseLayout>
  );
};

export default GeneralError;
